import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
import ParkinglocationModel from './ParkinglocationModel';
import EpoExternallocationModel from './EpoExternallocationModel';

const BASE = BaseModel.getApiBasePath() + '/api/v1/epo/parkinglocations';

export default new class EpoParkinglocationModel {

  get(id) {
    return new Promise((resolve, reject) => {
      this.getAll()
        .then((data) => {
          resolve(_.find(data, { id: id }));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAll(force = false) {
    return new Promise((resolve, reject) => {
      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then(async (response) => {            
            Promise
              .all([ParkinglocationModel.getAll(), EpoExternallocationModel.getAll()])
              .then(rolls => {
                let data = [];
                response.data.map(async (child, idx) => {
                  let location = _.find(rolls[0], { id: child.ParkingLocationID });
                  let exterllocation = _.find(rolls[1], { guid: child.ExtID });
                  data.push(Object.assign({}, child, { 
                    ParkingLocationName: location ? location.Code + ' - ' + location.Name : 'Neznámá lokalita', 
                    ExternallocationName: exterllocation ? exterllocation.code + ' - ' + exterllocation.name : 'Neznámá lokalita' 
                  }));                    
                });
                resolve(data);
              });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  create(data) {
    return new Promise((resolve, reject) => {
      axios.post(BASE, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  remove(id) {
    return new Promise((resolve, reject) => {
      axios.delete(BASE + '/' + id, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

}


// WEBPACK FOOTER //
// ./src/components/EpoParkinglocationModel.js